// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsView";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { GridOffset } from "@insite/mobius/GridContainer";
import { LoadingSpinnerStyle } from "@insite/mobius/LoadingSpinner";
import { css } from "styled-components";

const hideWhenEmpty = css`
    ${({ isShellEditingMode }: any) => {
        if (!isShellEditingMode) {
            return css`
                &:has(> div:empty) {
                    display: none;
                }
            `;
        }
    }}
`;

viewStyles.container = {
    gap: 0,
    css: css`
        ${LoadingSpinnerStyle} {
            display: none;
        }
        & > ${GridOffset} {
            display: grid;
        }
    `,
    offsetCss: css`
        grid-template-columns: 658px minmax(0, 1fr);
        column-gap: 22px;
        grid-template-areas:
            "image info"
            "image actions"
            "image ."
            "wide wide";
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, minmax(0, 50%));
            column-gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: minmax(0, 100%);
            grid-template-areas:
                "info"
                "image"
                "actions"
                "wide";
        }

        @media print {
            display: block;
        }
    `,
};

viewStyles.leftColumnGridItem = {
    width: 12,
    css: css`
        grid-area: image;
        height: 543px;
        ${xScreen("lte", "md")} {
            height: auto;
        }
        ${xScreen("lte", "sm")} {
            margin-bottom: -24px;
        }
    `,
};

viewStyles.rightColumnGridItem = {
    width: 12,
    css: css`
        grid-area: info;
        flex-direction: column;
    `,
};
viewStyles.rightBottomColumnGridItem = {
    width: 12,
    css: css`
        grid-area: actions;
    `,
};

viewStyles.actions = {
    css: css`
        width: 100%;
    `,
};
viewStyles.imageSection = {
    css: css`
        width: 100%;
    `,
};

viewStyles.bottomGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 48px;
        }
        grid-area: wide;
        display: grid;
        grid-template-columns: 1fr minmax(300px, 430px);
        gap: 48px 22px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};
viewStyles.breadcrumbsAndLinksContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 12px 8px;
        align-items: center;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 12px;
        }
    `,
};

viewStyles.breadcrumbsContainer = {
    css: css`
        ${xScreen("lte", "sm")} {
            nav {
                padding-bottom: 0;
            }
        }
    `,
};

viewStyles.specificationsSection = {
    css: css`
        grid-column: 1 / 2;
        ${xScreen("lte", "md")} {
            grid-column: 1 / -1;
        }
        ${hideWhenEmpty}
    `,
};
viewStyles.documentsSection = {
    css: css`
        grid-column: 2 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / -1;
        }
        ${hideWhenEmpty}
    `,
};
viewStyles.carouselSection = {
    css: css`
        grid-column: 1 / 3;
        overflow: hidden;
        ${xScreen("lte", "md")} {
            grid-column: 1 / -1;
        }
        ${hideWhenEmpty}
    `,
};
viewStyles.productOptions = {
    css: css`
        grid-column: 1 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / -1;
        }
        ${hideWhenEmpty}
    `,
};
viewStyles.bannerSection = {
    css: css`
        margin-bottom: 48px;
        ${hideWhenEmpty}
    `,
};
